import { alpha, Grid, styled, Typography } from '@mui/material';

export const TwoArrowGrid = styled(Grid)(({ theme: _theme }) => ({
    width: '32px',
    height: '32px',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    borderRadius: '8px',
    padding: '0 2px',
}));

export const ProjectHeaderText = styled(Typography)(({ theme }) => ({
    color: alpha(theme.custom.c18, 0.4),
    fontSize: '0.625rem',
    fontWeight: 700,
    textTransform: 'uppercase',
}));
